import { Component, ViewChild, forwardRef, Inject } from "@angular/core";

import { MapDataService } from "../../commons/map-data.service";
import { FourDService, Project, TransformGroup, Transform, Annotation, PlottableModel } from "4d-mapper";
import { ActivatedRoute, Router } from "@angular/router";
import { MapEventService } from "../../commons/map-event.service";
import { Coordinate } from "../../commons/map-event.objects";
import { filter, take, tap } from "rxjs/operators";
import { Observable } from "rxjs";


@Component({
  selector: 'detail-comp',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent {

  layer:Transform
  photo:Transform
  annot:Annotation
  opacity:number
 
  constructor(private route:ActivatedRoute,private router:Router, public mapData:MapDataService, public mapEvents:MapEventService) {

  }

  ngOnInit(){

    this.mapData.onSceneReady().subscribe(s => {
 
        this.route.params.subscribe(params => {
          this.layer = null
          this.annot = null
          var layerId = parseInt(params.layerId)
          var obs:Observable<any>
          if(params.objType == 'annot')
            obs = this.mapData.annotations.events.pipe(filter(a => a.item.id == layerId && a.event == 'ADD'),take(1),tap(a => 
              this.annot = a.item
            ))
          
          else if(params.objType == 'job')
            obs = this.mapData.scenePhotos.events.pipe(filter(a => a.item.id == layerId && a.event == 'ADD'),take(1),tap(a => 
              this.photo = a.item
            ))

          else if(params.objType == 'photo')
            obs = this.mapData.scenePhotos.events.pipe(filter(a => a.item.id == layerId && a.event == 'ADD'),take(1),tap(a => 
              this.photo = a.item
            ))

          else
            obs = this.mapData.sceneLayers.events.pipe(filter(a => a.item.id == layerId && a.event == 'ADD'),take(1),tap(a => {
              this.layer = a.item
              this.opacity = this.mapData.scene.value.getAlpha(this.layer)
            }))
          
          // clear the cursor
          this.mapEvents.cursor.value = null
          
          this.mapEvents.setClickListener(this)

          obs.subscribe(_ => {
            // dont move camera unless asked
            if(params.jump == 'true')
                this.mapEvents.flyCameraTo(this.layer || this.photo || this.annot)
          })
        })

   
    })
  
  }
  ngOnDestroy(){
    this.mapEvents.clearClickListener(this)
  
  }
  changeAlpha(){
    this.mapData.scene.value.setAlpha(this.layer,this.opacity)
    this.mapData.scene.value.saveObservable().subscribe()
    this.mapData.displayedLayers.set(this.layer)
  }

  onMapClicked(position: Coordinate, feature: PlottableModel<any>):boolean {

    console.log('DetailsComponent',position, feature)
    // return false means still do super event
    return false
  }

  delete(){
    if(confirm('Sure?')){
      if(this.annot){
        this.annot.destroyObservable().subscribe(_ => this.mapData.annotations.remove(this.annot))
      }
      if(this.layer){
        this.mapData.scene.value.children.removeObservable(this.layer).subscribe(_ => this.mapData.sceneLayers.remove(this.layer))
      }
      if(this.photo){
        this.mapData.scene.value.photos.removeObservable(this.layer).subscribe(_ => this.mapData.scenePhotos.remove(this.photo))
      }

    }
  }

}